module.exports = __webpack_public_path__ + "fonts/SamsungOne-800v10.438687b6.woff2";